import { proxyCustomElement, HTMLElement, createEvent, h } from '@stencil/core/internal/client';
import { d as defineCustomElement$1 } from './form-control-checkbox2.js';

const SaveNewPaymentMethod = /*@__PURE__*/ proxyCustomElement(class SaveNewPaymentMethod extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.checkboxChanged = createEvent(this, "checkboxChanged", 7);
        this.isChecked = false;
    }
    handleCheckboxChange(_name, value) {
        this.isChecked = value;
        this.checkboxChanged.emit(this.isChecked);
    }
    render() {
        return (h("div", { key: 'e6e7a75237ec2062188bf85deadac58892663b3b', class: "mt-4 form-check" }, h("form-control-checkbox", { key: 'abbaeb4e9119c4d41f0a727c7a070c14b7418302', label: "Save new payment method", name: "saveNewPaymentMethod", checked: this.isChecked, inputHandler: this.handleCheckboxChange.bind(this) })));
    }
}, [0, "justifi-save-new-payment-method", {
        "isChecked": [32]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["justifi-save-new-payment-method", "form-control-checkbox"];
    components.forEach(tagName => { switch (tagName) {
        case "justifi-save-new-payment-method":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, SaveNewPaymentMethod);
            }
            break;
        case "form-control-checkbox":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { SaveNewPaymentMethod as S, defineCustomElement as d };
